<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getStorageDocuments.length > 0 && $store.getters.getStorageDocumentsLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'inventory_id',
            'inventory_date',
            'common_user',
            'inventory_destination',
            'inventory_status',
            'inventory_dateCompleted',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('inventory_id.localization_value.value') }}</th>
            <th>{{ $t('inventory_date.localization_value.value') }}</th>
            <th v-if="isAdmin">{{ $t('common_user.localization_value.value') }}</th>
<!--            <th v-if="isAdmin">{{ $t('inventory_destination.localization_value.value') }}</th>-->
            <th>{{ $t('inventory_status.localization_value.value') }}</th>
            <th>{{ $t('inventory_dateCompleted.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{$t('common_manage.localization_value.value')}}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getStorageDocuments" :key="index">
            <td>
              <router-link
                  :to="$store.getters.GET_PATHS.mainSettingsInventory + '/show/' + item.id"
                  class="table-link btn-style">
                #{{item.id}}
              </router-link>
            </td>

            <td>{{ item.requested_date | moment("DD MMM, YYYY") }}</td>

            <td v-if="isAdmin">
              <TableUserColumn :item="item" />
            </td>

<!--            <td v-if="isAdmin"></td>-->

            <td>
              <template v-if="item.status === 'completed'">
                <StatusIcoBtn :type="'active'" class="mr-1"/>
                {{$t('inventory_Completed.localization_value.value')}}
              </template>
              <template v-if="item.status === 'draft'">
                <StatusIcoBtn :type="'in-transit'" class="mr-1"/>
                {{$t('inventory_inProcess.localization_value.value')}}
              </template>
            </td>

            <td>
              <span v-if="item.status === 'completed'">
                <ValueHelper
                    :value="item['updated_at']"
                    :date="true"
                    :dateType="'DD MMM, YYYY'"
                />
              </span>
              <span v-else>—</span>
            </td>
            
            <td width="100%" class="hide-1400"></td>

            <td>
              <div class="d-flex">
                <router-link
                    class="mr-3"
                    :to="$store.getters.GET_PATHS.mainSettingsInventory + '/edit/' + item.id">
                  <LinkButton
                      v-if="isAdmin && item.status !== 'completed'"
                      :value="$t(`common_edit.localization_value.value`)"
                      :type="'edit'"
                  />
                </router-link>

                <LinkButton
                    v-if="item.status !== 'completed'"
                    :value="$t(`common_delete.localization_value.value`)"
                    :type="'delete'"
                    @click.native="deleteItem(item.id, index)"
                />
              </div>

            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getStorageDocuments"
                 :key="index"
            >
              <InventoryTableMobile :item="item"/>
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getStorageDocumentsCommonList.next_page_url !== null && $store.getters.getStorageDocuments.length > 0"
                    @click.native="$emit('showMore')"
                    v-bind:class="{'disabled-btn' : $store.getters.getNextStorageDocumentsPage}"
                    :count="$store.getters.getStorageDocumentsCommonList.total - $store.getters.getStorageDocumentsForPage < $store.getters.getStorageDocumentsForPage ?
                    $store.getters.getStorageDocumentsCommonList.total - $store.getters.getStorageDocumentsForPage:
                    $store.getters.getStorageDocumentsForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getStorageDocumentsLoading === false && $store.getters.getStorageDocuments.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>
  </div>
</template>

<script>
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import InventoryTableMobile from "./InventoryTableMobile/InventoryTableMobile";
  import TableUserColumn from "../../../../../../coreComponents/TableComponents/TableUserColumn/TableUserColumn";
  import {mixinDetictingMobile} from "@/mixins/mobileFunctions";
  import LinkButton from "@/components/UI/buttons/LinkButton/LinkButton";
  import StatusIcoBtn from "@/components/UI/status/StatusIcoBtn/StatusIcoBtn";
  import ValueHelper from "@/components/coreComponents/ValueHelper/ValueHelper";

  export default {
    name: "InventoryTable",
    components: {
      ValueHelper,
      StatusIcoBtn,
      LinkButton,
      TableUserColumn,
      InventoryTableMobile,
      NoResult,
      ShowMore,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalNegativeBalancePopup: false,

      }
    },

    methods: {
      changeNegativeBalancePopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalNegativeBalancePopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id, index) {
        let text = {
          title: 'common_deleteConfirm',
          txt: 'common_deleteItemAsk',
          yes: 'common_confirmDelete',
          no: 'common_confirmNo'
        }

        let confirm = () => {

          this.$store.dispatch('deleteStorageDocuments', id).then((response) => {
            if (this._.has(response, 'data') && response.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {

              let storageDocuments = this.$store.getters.getStorageDocuments
              storageDocuments.splice(index, 1)

              this.openNotify('success', 'common_notificationRecordDeleted')
            } else {
              setTimeout(() => {
                this.openNotify('error', 'common_notificationUndefinedError')
              }, 200)
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
